import { UserIdentificationData } from "Store/userIdentification/userIdentificationInterfaces";
import { isDefined } from "./functions";

export const isSTBEmployee = (user: UserIdentificationData | null): boolean => {
  if (!isDefined(user)) {
    return false;
  }

  const agreementProduct = user.discountResponse.f2100.agreementProduct;
  return agreementProduct === 500 || agreementProduct === 501;
};
